import { Button, Stack } from '@mui/material'
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline'
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline'
import { MouseEvent, useState } from 'react'
import { Driver } from '../../../../../store/drivers/drivers.type'
import {
  ItemContainer,
  Meta,
  Name,
  NameContainer,
} from './driver-list-item.styles'
import DriverUpdateDialog from '../../../driver-update-dialog/driver-update-dialog.component'
import DriverDeleteDialog from '../../../driver-delete-dialog/driver-delete-dialog.component'

interface DriverListItemProps {
  driver: Driver
  isSelected: boolean
  handleDriverSelect: () => void
}

const actionButtonSx = {
  flex: 1,
  minWidth: 0,
  borderRadius: '8px',
  textTransform: 'none',
  fontWeight: 600,
  paddingX: '10px',
  paddingY: '6px',
} as const

const DriverListItem = ({
  driver,
  isSelected,
  handleDriverSelect,
}: DriverListItemProps) => {
  const [updateOpen, setUpdateOpen] = useState(false)
  const [deleteOpen, setDeleteOpen] = useState(false)

  const driverName = `${driver?.firstName ?? ''} ${driver?.lastName ?? ''}`.trim()
  const displayName = driverName || driver?.phone || ''
  const showPhone = Boolean(driverName && driver?.phone)

  const handleUpdate = (e: MouseEvent) => {
    e.stopPropagation()
    handleDriverSelect()
    setUpdateOpen(true)
  }

  const handleDelete = (e: MouseEvent) => {
    e.stopPropagation()
    handleDriverSelect()
    setDeleteOpen(true)
  }

  return (
    <ItemContainer $selected={isSelected} onClick={handleDriverSelect}>
      <NameContainer $selected={isSelected}>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          spacing={1}
        >
          <Name>{displayName}</Name>
          {showPhone && <Meta $selected={isSelected}>{driver.phone}</Meta>}
        </Stack>
        <Meta $selected={isSelected}>
          Drive App Status: {driver?.driverAppStatus || 'New'}
        </Meta>
      </NameContainer>
      <Stack
        direction="row"
        spacing={1}
        sx={{
          padding: '8px 12px 12px',
          bgcolor: isSelected ? '#E8F3FC' : 'common.white',
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <Button
          variant="outlined"
          startIcon={<CheckCircleOutlineIcon />}
          onClick={handleUpdate}
          sx={{
            ...actionButtonSx,
            borderColor: 'primary.main',
            color: 'primary.main',
            '&:hover': {
              borderColor: 'primary.dark',
              bgcolor: 'rgba(25, 118, 210, 0.04)',
            },
          }}
        >
          Update Driver
        </Button>
        <Button
          variant="outlined"
          color="error"
          startIcon={<DeleteOutlineIcon />}
          onClick={handleDelete}
          sx={actionButtonSx}
        >
          Delete Driver
        </Button>
      </Stack>
      {updateOpen && (
        <DriverUpdateDialog
          open={updateOpen}
          handleClose={() => setUpdateOpen(false)}
          driver={driver}
        />
      )}
      {deleteOpen && (
        <DriverDeleteDialog
          open={deleteOpen}
          handleClose={() => setDeleteOpen(false)}
          driver={driver}
        />
      )}
    </ItemContainer>
  )
}

export default DriverListItem
